module.exports = __webpack_public_path__ + "static/media/yellow_card.7151a527.svg";